import React, { useEffect, useState } from "react";
import { Input } from "antd";
//@ts-ignore
import s from './InputStandard.module.scss'
import { debounce } from "../../../store/utils/utilsFunc";
import { useDispatch, useSelector } from "react-redux";
import { getValueOption, valueOption } from "../../../store/selectors/selectors";
import { setValueOptions } from "../../../store/actions/setting";



export type inputComponentsT = {
    id: string,
    placeholder?: string,
    type?: string,
}

export const InputStandard = ({ ...props }: inputComponentsT) => {
    let { placeholder, type, id } = props;

    type = 'number'
    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({idOptions: id})(state));

    const dispatch = useDispatch();

    function onChangeValue(val: any) {
        dispatch(setValueOptions({ idParams: id, valueParam: val.target.value }))
    }

    let classInput = `${s.input}`
    if (isError) classInput += `  ${s.input_error}`

    return (
        <div className={s.wrap} >
            <input defaultValue={selectValue} className={classInput} onChange={debounce(onChangeValue, 500)} name={id} placeholder={placeholder} type={type} />
        </div>
    )
}
